import styles from './styles.module.css';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSearchParams } from 'react-router-dom';

function Banners() {
  const banners = useBanners();

  return (
    <>
      {banners.map((message, i) => (
        <Banner key={`${i}-${message}`} message={message} />
      ))}
    </>
  );
}

export default Banners;

function Banner({ message }: { message: string }) {
  return (
    <div className={styles.banner}>
      <FontAwesomeIcon icon={faCheck} className={styles.checkIcon} />
      <span>{message}</span>
    </div>
  );
}

function useBanners() {
  const [searchParams] = useSearchParams();
  const message = searchParams.get('success');
  return message ? [message] : [];
}
